import { ButtonProps, TextFieldProps } from '@alliander-fe/sitecore-types';
import { LinkField, RichTextField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { CongestionCheckerParticulier as CongestionChecker } from 'src/components/CongestionCheckerParticulier';

import { ComponentProps } from 'src/jss/lib/component-props';
import {
  FilterValuePropertyFromFields,
  mapWithoutValueProperty,
} from 'src/utils/mapWithoutValueProperty';

export type SitecoreCongestionCheckerParticulierV2Field = {
  feedbackNoScarcityTitle: TextFieldProps;
  feedbackNoScarcityText: RichTextField;
  feedbackNoScarcityPrimaryButton: LinkField;
  feedbackNoScarcitySecondaryButton: LinkField;

  additionalInfoBlockNoScarcityTitle: TextFieldProps;
  additionalInfoBlockNoScarcityText: RichTextField;
  additionalInfoBlockNoScarcityPrimaryButton: LinkField;
  additionalInfoBlockNoScarcitySecondaryButton: LinkField;

  conclusionNoScarcityUpperText: RichTextField;
  conclusionNoScarcityFirstPrimaryButton: LinkField;
  conclusionNoScarcityFirstSecondaryButton: LinkField;
  conclusionNoScarcityLowerText: RichTextField;
  conclusionNoScarcitySecondPrimaryButton: LinkField;
  conclusionNoScarcitySecondSecondaryButton: LinkField;

  feedbackAllConnectionsPossibleTitle: TextFieldProps;
  feedbackAllConnectionsPossibleText: RichTextField;
  feedbackAllConnectionsPossiblePrimaryButton: LinkField;
  feedbackAllConnectionsPossibleSecondaryButton: LinkField;

  additionalInfoBlockAllConnectionsPossibleTitle: TextFieldProps;
  additionalInfoBlockAllConnectionsPossibleText: RichTextField;
  additionalInfoBlockAllConnectionsPossiblePrimaryButton: LinkField;
  additionalInfoBlockAllConnectionsPossibleSecondaryButton: LinkField;

  conclusionAllConnectionsPossibleUpperText: RichTextField;
  conclusionAllConnectionsPossibleFirstPrimaryButton: LinkField;
  conclusionAllConnectionsPossibleFirstSecondaryButton: LinkField;
  conclusionAllConnectionsPossibleLowerText: RichTextField;
  conclusionAllConnectionsPossibleSecondPrimaryButton: LinkField;
  conclusionAllConnectionsPossibleSecondSecondaryButton: LinkField;

  feedbackSmallConnectionsPossibleTitle: TextFieldProps;
  feedbackSmallConnectionsPossibleText: RichTextField;
  feedbackSmallConnectionsPossiblePrimaryButton: LinkField;
  feedbackSmallConnectionsPossibleSecondaryButton: LinkField;

  additionalInfoBlockSmallConnectionsPossibleTitle: TextFieldProps;
  additionalInfoBlockSmallConnectionsPossibleText: RichTextField;
  additionalInfoBlockSmallConnectionsPossiblePrimaryButton: LinkField;
  additionalInfoBlockSmallConnectionsPossibleSecondaryButton: LinkField;

  conclusionSmallConnectionsPossibleUpperText: RichTextField;
  conclusionSmallConnectionsPossibleFirstPrimaryButton: LinkField;
  conclusionSmallConnectionsPossibleFirstSecondaryButton: LinkField;
  conclusionSmallConnectionsPossibleLowerText: RichTextField;
  conclusionSmallConnectionsPossibleSecondPrimaryButton: LinkField;
  conclusionSmallConnectionsPossibleSecondSecondaryButton: LinkField;

  feedbackGridIsFull3YearsTitle: TextFieldProps;
  feedbackGridIsFull3YearsText: RichTextField;
  feedbackGridIsFull3YearsPrimaryButton: LinkField;
  feedbackGridIsFull3YearsSecondaryButton: LinkField;

  additionalInfoBlockGridIsFull3YearsTitle: TextFieldProps;
  additionalInfoBlockGridIsFull3YearsText: RichTextField;
  additionalInfoBlockGridIsFull3YearsPrimaryButton: LinkField;
  additionalInfoBlockGridIsFull3YearsSecondaryButton: LinkField;

  conclusionGridIsFull3YearsUpperText: RichTextField;
  conclusionGridIsFull3YearsFirstPrimaryButton: LinkField;
  conclusionGridIsFull3YearsFirstSecondaryButton: LinkField;
  conclusionGridIsFull3YearsLowerText: RichTextField;
  conclusionGridIsFull3YearsSecondPrimaryButton: LinkField;
  conclusionGridIsFull3YearsSecondSecondaryButton: LinkField;

  feedbackGridIsFullXYearsTitle: TextFieldProps;
  feedbackGridIsFullXYearsText: RichTextField;
  feedbackGridIsFullXYearsPrimaryButton: LinkField;
  feedbackGridIsFullXYearsSecondaryButton: LinkField;

  additionalInfoBlockGridIsFullXYearsTitle: TextFieldProps;
  additionalInfoBlockGridIsFullXYearsText: RichTextField;
  additionalInfoBlockGridIsFullXYearsPrimaryButton: LinkField;
  additionalInfoBlockGridIsFullXYearsSecondaryButton: LinkField;

  conclusionGridIsFullXYearsUpperText: RichTextField;
  conclusionGridIsFullXYearsFirstPrimaryButton: LinkField;
  conclusionGridIsFullXYearsFirstSecondaryButton: LinkField;
  conclusionGridIsFullXYearsLowerText: RichTextField;
  conclusionGridIsFullXYearsSecondPrimaryButton: LinkField;
  conclusionGridIsFullXYearsSecondSecondaryButton: LinkField;
};

export type SitecoreCongestionCheckerParticulierV1Field = {
  feedbackPurpleTitle: TextFieldProps;
  feedbackPurpleText: RichTextField;
  feedbackPurplePrimaryButton: LinkField;
  feedbackPurpleSecondaryButton: LinkField;

  additionalInfoBlockPurpleTitle: TextFieldProps;
  additionalInfoBlockPurpleText: RichTextField;
  additionalInfoBlockPurplePrimaryButton: LinkField;
  additionalInfoBlockPurpleSecondaryButton: LinkField;

  conclusionPurpleUpperText: RichTextField;
  conclusionPurpleFirstPrimaryButton: LinkField;
  conclusionPurpleFirstSecondaryButton: LinkField;

  conclusionPurpleLowerText: RichTextField;
  conclusionPurpleSecondPrimaryButton: LinkField;
  conclusionPurpleSecondSecondaryButton: LinkField;

  feedbackRedTitle: TextFieldProps;
  feedbackRedText: RichTextField;
  feedbackRedPrimaryButton: LinkField;
  feedbackRedSecondaryButton: LinkField;

  additionalInfoBlockRedTitle: TextFieldProps;
  additionalInfoBlockRedText: RichTextField;
  additionalInfoBlockRedPrimaryButton: LinkField;
  additionalInfoBlockRedSecondaryButton: LinkField;

  conclusionRedUpperText: RichTextField;
  conclusionRedFirstPrimaryButton: LinkField;
  conclusionRedFirstSecondaryButton: LinkField;

  conclusionRedLowerText: RichTextField;
  conclusionRedSecondPrimaryButton: LinkField;
  conclusionRedSecondSecondaryButton: LinkField;

  feedbackGridFullTitle: TextFieldProps;
  feedbackGridFullText: RichTextField;
  feedbackGridFullPrimaryButton: LinkField;
  feedbackGridFullSecondaryButton: LinkField;

  additionalInfoBlockGridFullTitle: TextFieldProps;
  additionalInfoBlockGridFullText: RichTextField;
  additionalInfoBlockGridFullPrimaryButton: LinkField;
  additionalInfoBlockGridFullSecondaryButton: LinkField;

  conclusionGridFullUpperText: RichTextField;
  conclusionGridFullFirstPrimaryButton: LinkField;
  conclusionGridFullFirstSecondaryButton: LinkField;

  conclusionGridFullLowerText: RichTextField;
  conclusionGridFullSecondPrimaryButton: LinkField;
  conclusionGridFullSecondSecondaryButton: LinkField;

  feedbackYellowTitle: TextFieldProps;
  feedbackYellowText: RichTextField;
  feedbackYellowPrimaryButton: LinkField;
  feedbackYellowSecondaryButton: LinkField;

  additionalInfoBlockYellowTitle: TextFieldProps;
  additionalInfoBlockYellowText: RichTextField;
  additionalInfoBlockYellowPrimaryButton: LinkField;
  additionalInfoBlockYellowSecondaryButton: LinkField;

  conclusionYellowUpperText: RichTextField;
  conclusionYellowFirstPrimaryButton: LinkField;
  conclusionYellowFirstSecondaryButton: LinkField;

  conclusionYellowLowerText: RichTextField;
  conclusionYellowSecondPrimaryButton: LinkField;
  conclusionYellowSecondSecondaryButton: LinkField;

  feedbackNoneTitle: TextFieldProps;
  feedbackNoneText: RichTextField;
  feedbackNonePrimaryButton: LinkField;
  feedbackNoneSecondaryButton: LinkField;

  additionalInfoBlockNoneTitle: TextFieldProps;
  additionalInfoBlockNoneText: RichTextField;
  additionalInfoBlockNonePrimaryButton: LinkField;
  additionalInfoBlockNoneSecondaryButton: LinkField;

  conclusionNoneUpperText: RichTextField;
  conclusionNoneFirstPrimaryButton: LinkField;
  conclusionNoneFirstSecondaryButton: LinkField;

  conclusionNoneLowerText: RichTextField;
  conclusionNoneSecondPrimaryButton: LinkField;
  conclusionNoneSecondSecondaryButton: LinkField;
};

export type SitecoreCongestionCheckerParticulierProps = ComponentProps & {
  fields: {
    title: TextFieldProps;
    postcode: ButtonProps;
    huisnr: TextFieldProps;
    explanation: RichTextField;
    inputFormTitle: TextFieldProps;
    inputFormText: TextFieldProps;
    submitButtonLabel: TextFieldProps;

    useApiEndpointVersionTwo: {
      value: boolean;
    };

    disclaimerTextCongestionNearbyConnection: RichTextField;

    errorTitle: TextFieldProps;
    errorMessage: RichTextField;

    errorTitleAddressHasNoLowVoltageConnection: TextFieldProps;
    errorMessageAddressHasNoLowVoltageConnection: RichTextField;

    errorTitleOtherGridOperatorElectricity: TextFieldProps;
    errorMessageOtherGridOperatorElectricity: RichTextField;

    errorTitlePostalCodeHouseNumberNotFound: TextFieldProps;
    errorMessagePostalCodeHouseNumberNotFound: RichTextField;
  } & SitecoreCongestionCheckerParticulierV2Field &
    SitecoreCongestionCheckerParticulierV1Field;
};

export type FilteredCongestionCheckerParticulierProps = FilterValuePropertyFromFields<
  SitecoreCongestionCheckerParticulierProps['fields']
>;

const CongestionCheckerParticulier = (props: SitecoreCongestionCheckerParticulierProps) => {
  const mappedFields = mapWithoutValueProperty(props.fields);

  return <CongestionChecker {...mappedFields} />;
};

export default withDatasourceCheck()<SitecoreCongestionCheckerParticulierProps>(
  CongestionCheckerParticulier
);
